import { render, staticRenderFns } from "./advice_information_list.vue?vue&type=template&id=e850d402&scoped=true&"
import script from "./advice_information_list.vue?vue&type=script&lang=js&"
export * from "./advice_information_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e850d402",
  null
  
)

export default component.exports